import React from 'react';
import type { TopUpPack } from '../../services/walletService';

export interface StarterPackCardProps {
  pack: TopUpPack;
  /** Pack id currently being checked out, or '' when idle. */
  buying: string;
  onBuy: (packId: string) => void;
}

/**
 * THE STARTER PACK (ROADMAP TRY-3) — the first option an eligible creator sees: one card, what it costs, what it
 * holds, and what that is enough for. Shown only while the server says this account has never bought a pack;
 * the server refuses the checkout otherwise, so this card is an offer, never the gate.
 *
 * Same card idiom as the ladder (TopUpPacks): a bordered tile, a monochrome chip, the price large, one black
 * action. It is not a step on the ladder, so it sits above it rather than inside it. Presentational.
 */
const StarterPackCard: React.FC<StarterPackCardProps> = ({ pack, buying, onBuy }) => (
  <div data-testid="starter-pack"
    className="relative rounded-2xl border border-secondary-900 dark:border-white p-4 flex flex-wrap items-center justify-between gap-3">
    <span className="absolute -top-2 left-4 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-secondary-900 dark:bg-white text-white dark:text-secondary-900">
      First purchase
    </span>
    <div className="min-w-0">
      <p className="font-semibold">
        Starter <span className="font-normal text-secondary-500">— ${pack.price_usd}, {pack.credits.toLocaleString()} credits</span>
      </p>
      <p className="mt-0.5 text-xs text-secondary-500">Enough to animate and publish your first episode. One time only.</p>
    </div>
    <button onClick={() => onBuy(pack.id)} disabled={!!buying} data-testid="buy-starter"
      className="px-3 py-2 rounded-xl bg-secondary-900 dark:bg-white text-white dark:text-secondary-900 text-sm font-medium hover:bg-black dark:hover:bg-secondary-100 transition-colors disabled:opacity-50">
      {buying === pack.id ? 'Starting…' : `Buy for $${pack.price_usd}`}
    </button>
  </div>
);

export default StarterPackCard;
